import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Skeleton from '@/components/@IntranetLibrary/Skeleton';

// datepicker/skeleton 디자인(node 26255:504788) 이식.
// 첫 줄은 제목 placeholder(짧게), 이후는 본문 라인 placeholder.
const BAR_WIDTHS = ['25.46%', '100%', '92.02%'];

/**
 * AI 정리 진행 중 본문 영역에 표시하는 스켈레톤.
 * 안내 문구 2줄(gray6) + 회색 바 3개.
 */
const OrganizingSkeleton = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
      }}
    >
      <Box
        component="p"
        sx={{
          margin: 0,
          fontSize: '14px',
          lineHeight: '20px',
          fontWeight: 400,
          color: 'var(--dk-text-secondary, #888D96)',
          wordBreak: 'break-word',
        }}
      >
        {t('AI가 정리하고 있어요.')}
        <br />
        {t('완료되면 알림을 드릴게요.')}
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {BAR_WIDTHS.map((width, i) => (
          <Skeleton
            // 고정 순서 목록이라 index key 사용 (재정렬/삭제 없음)
            // eslint-disable-next-line react/no-array-index-key
            key={i}
            variant="rect"
            width={width}
            height={24}
          />
        ))}
      </Box>
    </Box>
  );
};

export default OrganizingSkeleton;
